export const ERROR_CODE = {
    FORBIDDEN: 403
}